import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { CSRForm } from "@/components/forms/CSRForm";
import { Building2, FileText, TrendingUp, Handshake } from "lucide-react";

export const CSRSection = () => (
  <section id="csr" className="navy-band text-white relative overflow-hidden">
    <div className="absolute inset-0 grain" aria-hidden="true" />
    <div className="container-wide relative py-16 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="eyebrow text-[hsl(var(--orange))]">CSR Partnership</div>
          <h2 className="heading-2 text-white mt-3">Partner with a Section 135-ready NGO.</h2>
          <p className="text-white/85 mt-4">CAF is CSR-1 registered and delivers structured project MoUs, quarterly outcome reports and audited utilization certificates — for every rupee, every quarter.</p>
          <div className="mt-6 grid grid-cols-2 gap-3">
            {[[Building2, "CSR-1 registered"], [FileText, "Audited UCs"], [Handshake, "MoUs ≤ 21 days"], [TrendingUp, "Quarterly outcomes"]].map(([Icon, t]) => (
              <div key={t} className="flex items-center gap-3 rounded-lg border border-white/15 bg-white/5 p-3"><div className="h-9 w-9 rounded-md bg-white/10 grid place-items-center text-[hsl(var(--orange))]"><Icon className="h-4.5 w-4.5" /></div><div className="text-sm">{t}</div></div>
            ))}
          </div>
        </div>
        <div className="lg:col-span-7">
          <Reveal><div className="rounded-xl border border-white/10 bg-card p-6 text-[hsl(var(--ink))]"><CSRForm /></div></Reveal>
        </div>
      </div>
    </div>
  </section>
);
